import { inject, Injectable, signal } from '@angular/core';
import  Keycloak, { KeycloakProfile }  from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class ErpKeycloakService {
  private readonly keycloak = inject(Keycloak)
  private readonly currentUser = signal<KeycloakProfile | null>(null)

  public setUser() {
    this.keycloak.loadUserProfile().then(res => this.currentUser.set(res))
  }
    
  public getUser(): KeycloakProfile | null {
    return this.currentUser()
  }

  public logout(): Promise<void> {
    return this.keycloak.logout()
  }

  public getTokenParsed() {
    return this.keycloak.tokenParsed
  }
}